import { getFileAttributes } from '../..';
export var createPreviewUnsupportedEvent = function createPreviewUnsupportedEvent(fileState) {
  var _getFileAttributes = getFileAttributes(fileState),
    fileId = _getFileAttributes.fileId,
    fileMediatype = _getFileAttributes.fileMediatype,
    fileMimetype = _getFileAttributes.fileMimetype,
    fileSize = _getFileAttributes.fileSize;
  return {
    eventType: 'operational',
    actionSubject: 'mediaFile',
    action: 'previewUnsupported',
    attributes: {
      fileAttributes: {
        fileId: fileId,
        fileMediatype: fileMediatype,
        fileMimetype: fileMimetype,
        fileSize: fileSize
      }
    }
  };
};